import styled from 'styled-components'

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 150px;

	.field.select:not(.banco-container):not(.instituicao-container) {
		width: calc(100% - 16px);
	}

	.field.checkbox {
		width: calc(100% - 16px) !important;
	}
`
